<div class="post_reservation-container d-flex flex-column">

  <!--------------------------- HEADER -------------------------------------------------------------------------------->
  <div [class.pis-2]="!openedUserStep && !showPage"
       class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center sticky-top bg-white pb-2 pt-sm-2 header_container">
    <!--  logo LF pour mobile  -->
    <a class="navbar-logo d-block d-sm-none overflow-hidden position-relative pb-4 pb-sm-0" href="/">
      <img class="object-fit-contain" ngSrc="/assets/img/seoHeaderImg/LF_logo-horizontal-p-500.png" loading="lazy"
           alt="Logo Livinfrance" height="58" width="150">
    </a>


    <!--  titre + bouton  -->
    <div class="order-sm-first">
      <h1 class="title_1 d-flex flex-column gap-24 mb-sm-3 text-grad-blue">
        <span [ngClass]="{'d-none d-sm-block' : openedUserStep || showPage}">
          {{ "PROCESSES.ACCOMMODATION.POST_RESERVATION_V2.HEADER_TITLE" | translate }}
        </span>
        <button id="post_reservation-backButton" role="button" aria-label="Button : Go back"
                class="btn border w-fit-content px-3"
                type="button" (click)="openedUserStep = null; showPage = null" *ngIf="openedUserStep || showPage">
          <lf-icon class="lh-0" name="gradLeftChevron" height="15px" width="16px"></lf-icon>
        </button>
      </h1>
    </div>
  </div>
  <!-- sous titre -->
  <div class="text_2 sticky_subtitle bg-white pb-3 pis-2 col-12 col-lg-8" *ngIf="!openedUserStep && !showPage"
       [innerHTML]="'PROCESSES.ACCOMMODATION.POST_RESERVATION_V2.HEADER_TEXT' | translate"></div>

  <!-- loader -->
  <div class="w-100 d-flex justify-content-center mt-4" *ngIf="isLoading; else loadedTemplate">
    <div class="spinner-border text-primary"></div>
  </div>

  <!--------------------------- CONTENT -------------------------------------------------------------------------------->
  <ng-template #loadedTemplate>

    <div class="d-flex my-4 pt-sm-4 mb-sm-0 flex-column flex-lg-row"
         *ngIf="postReservationStateArray && postReservationStateArray.length > 0; else errorTemplate">

      <div class="w-100 flex-grow-1 dashboard_container">
        <!--    dashboard  -->
        <app-dashboard [postReservationStatesArray]="postReservationStateArray"
                       [postReservationStatesIds]="postReservationStatesIds"
                       [currentUserStateIndex]="currentUserStep" [locale]="locale"
                       (wantedState)="changeTemplate($event)"
                       *ngIf="!openedUserStep && !showPage ; else openedUserStepTemplate"></app-dashboard>


        <ng-template #openedUserStepTemplate>
          <!--     Etape post reservation   -->
          <app-template-step *ngIf="!showPage"
                             [locale]="locale"
                             [displayedStep]="openedUserStep"
                             [currentUserStep]="openedStep.id"
                             (wantContactPage)="openContactPage()"
                             (wantOtherStep)="onWantOtherStep($event)"></app-template-step>

          <!--     Page annexes   -->
          <app-template-contact *ngIf="showPage === 'contact'" [locale]="locale"
                                [partner]="partner"></app-template-contact>

          <!--    Boutons  -->
          <div class="mt-4" *ngIf="!showPage">
            <!--     Bouton suivant/next ; navigation entre les étapes   -->
            <button id="post_reservation-nextButton" role="button"
                    *ngIf="openedUserStep.next_step_id && postReservationStatesIds.indexOf(openedStep.id) !== (postReservationStatesIds.length -1)"
                    [disabled]="isUpdating" type="submit" class="btn btn-lf-primary d-flex gap-16 ms-auto" (click)="nextStep()">
              {{
                (openedUserStep.type === 'single' ||
                (openedUserStep.childs && openedUserStep.childs[openedUserStep.childs.length - 1].id === openedStep.id) ? 'COMMON.NEXT_STEP' : 'COMMON.NEXT') | translate
              }}
              <lf-icon height="12px" name="rightChevron" width="12px" *ngIf="!isUpdating"></lf-icon>
              <div class="spinner-border spinner-border-sm text-white my-auto" *ngIf="isUpdating"></div>
            </button>
          </div>
        </ng-template>

        <div class="mt-4 bg-grey br-16 p-3 text_2"
             [innerHTML]="'PROCESSES.ACCOMMODATION.POST_RESERVATION_V2.FOOTER' | translate:{name: partner.name}"></div>
      </div>
      <div class="col-12 col-lg-4 ms-lg-3">
        <img class="h-fit-content img-cover aspect-ratio_1-1 d-none d-lg-inline" alt=""
             src="/assets/img/post_booking/booking_accepted_{{locale}}.svg">

        <div class="mt-4 bg-grey br-16 p-3 subtitle_2 lh-sm">
          <span [innerHTML]="'PROCESSES.ACCOMMODATION.POST_RESERVATION_V2.HELP' | translate"></span>
          <a [href]="contactFormUrl" target="_blank"
             class="btn btn-secondary mt-3 w-100">{{ 'COMMON.CONTACT_US' | translate }}</a>
        </div>
      </div>

    </div>
    <ng-template #errorTemplate>
      <app-template-error></app-template-error>
    </ng-template>
  </ng-template>
</div>



